import { render, staticRenderFns } from "./GroupSiteWorkcenterWidget.vue?vue&type=template&id=bbfd8042&scoped=true&"
import script from "./GroupSiteWorkcenterWidget.vue?vue&type=script&lang=js&"
export * from "./GroupSiteWorkcenterWidget.vue?vue&type=script&lang=js&"
import style0 from "./GroupSiteWorkcenterWidget.vue?vue&type=style&index=0&id=bbfd8042&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbfd8042",
  null
  
)

export default component.exports